module.exports = __webpack_public_path__ + "media/customizations/trilogy/back-ef72cf1e5986429236b35a2080562fb3.jpg";